export enum BenefitsListPage {
  MieterPlus = 'MIETER_PLUS_BENEFITS_LIST_PAGE',
  WohnenPlus = 'WOHNEN_PLUS_BENEFITS_LIST_PAGE',
  KauferPlus = 'KAEUFER_PLUS_BENEFITS_LIST_PAGE',
}

export enum BenefitsListPageType {
  MieterPlus = 'mieterplus',
  WohnenPlus = 'wohnenplus',
  KauferPlus = 'kaeuferplus',
}
